export const routes = {
  home: '/',
  login: '/login',
  signin: '/signin',
  signup: '/signup',
  otpVerify: '/otp-verify',
  forgotPassword: '/forgot-password',
  resetPassword: '/change-password',
  userDetail: '/user-detail',
  createPassword: '/create-password',
  dashboard: '/dashboard',
  publicBillboards: '/billboards',
  publicBillboard: (id: string) => `/billboard/${id}`,
  screens: '/screens',
  screenDetail: (id: string) => `/screens/${id}`,
  nearbyScreens: '/nearby-screens',
  nearbyScreensLegacy: '/nearByBillboards',
  campaigns: '/campaigns',
  campaignCreate: '/campaigns/create',
  campaignCreateMode: (mode: string) => `/campaigns/create/${mode}`,
  campaignDetail: (id: string) => `/campaigns/${id}`,
  campaignRelaunch: (id: string) => `/campaigns/${id}/relaunch`,
  clients: '/clients',
  team: '/team',
  gallery: '/gallery',
  reports: '/reports',
  reportDetail: (id: string) => `/report-detail/${id}`,
  coupon: '/coupon',
  wishlist: '/wishlist',
  wallet: '/wallet',
  profile: '/profile',
  notifications: '/notification',
  tutorial: '/tutorial',
  appTutorial: '/app-tutorial',
  totalAnalytics: '/total-analytics',
  policies: '/policies',
  support: '/support',
  supportChat: (id: string) => `/support/chat/${id}`,
  status: '/status',
  maintenance: '/maintenance',
  /** Public Partner Personal & KYC registration (no auth). */
  partnerKycRegistration: '/partner/kyc-registration',
} as const;
